/**
 * 🟥 CUADRO NEGRO Panel de Suscripción Único (feb-2026).
 *
 * navigateToPremium — históricamente este helper hacía scroll a la
 * sección `[data-testid="premium-plan-section"]` en /planes-y-beneficios.
 * El cuadro negro vigente prohíbe redirigir a páginas informativas:
 * TODOS los CTAs Premium deben llevar al Panel de Suscripción real
 * (el widget con los botones $9 y $86 sobre el Área de Trabajo).
 *
 * Por compatibilidad con los muchos componentes que ya importan
 * `navigateToPremium`, ahora delega directamente en
 * `openSubscriptionPanel()` — un único punto de salida.
 */
import { openSubscriptionPanel } from './openSubscriptionPanel';

export const navigateToPremium = () => {
  openSubscriptionPanel();
};

export default navigateToPremium;
